import { ThemeProvider } from 'styled-components'
import { Icon20 } from 'builder/components/Icon'
import Colors from 'builder/styles/colors'
import * as Styles from './styles'

type Text = {
  title: string
  description: string
  items: string[]
}

type Props = {
  text: Text
  imageUrl: string
  action: React.ReactNode
  theme: {
    background: string
    text: string
  }
}

export const Banner = (props: Props) => {
  return (
    <ThemeProvider theme={props.theme}>
      <Styles.Container>
        <Styles.BannerSection>
          <Styles.Header>
            <Styles.Title>{props.text.title}</Styles.Title>
            <Styles.Description>{props.text.description}</Styles.Description>
          </Styles.Header>
          {props.imageUrl.endsWith('.webm') ? (
            <Styles.VideoWrapper>
              <Styles.Video src={props.imageUrl} autoPlay muted loop playsInline />
            </Styles.VideoWrapper>
          ) : (
            <Styles.ImageWrapper>
              <Styles.Image src={props.imageUrl} />
            </Styles.ImageWrapper>
          )}
        </Styles.BannerSection>
        <Styles.ActionSection>
          <Styles.List>
            {props.text.items.map((item, index) => (
              <Styles.Item key={index}>
                <Icon20.Check color={Colors.Green50} /> <span>{item}</span>
              </Styles.Item>
            ))}
          </Styles.List>
          <Styles.Action>{props.action}</Styles.Action>
        </Styles.ActionSection>
      </Styles.Container>
    </ThemeProvider>
  )
}
